module.exports = __webpack_public_path__ + "static/img/1_11_1.e40f535e.jpg";